import { Component, Input, OnInit } from '@angular/core';
import { PHOTO_REVIEW_UISTATE } from '../model/photo-review.constant';
import { SCHEMA_TYPE } from '../../model/quality.constant';
import {MapViewConfigModel} from '@cv-invision/cv.component-library.ux'

@Component({
	selector: 'cv-photo-tab',
	templateUrl: './photo-card-tab-content.component.html',
	styleUrls: ['./photo-card-tab-content.component.scss'],
})
export class PhotoCardTabComponent implements OnInit {

	messageType = PHOTO_REVIEW_UISTATE.MESSAGETYPE;
	schema = SCHEMA_TYPE;
	@Input() info: any;
	@Input() ruleType: string;
	@Input() SchemaType: string;

	public mapConfiguration = new MapViewConfigModel();
	/**
	 * cast a string number to a number type
	 * @param number
	 */
	castToInt(number: string): number {
		const numberCasted = Number(number);
		return isNaN(numberCasted) ? 0 : numberCasted;
	}

	ngOnInit(): void {
		this.mapConfiguration.setMainLocation(
			{
				latitude: this.castToInt(this.info.photoLatitude),
				longitude: this.castToInt(this.info.photoLongitude)
			}
		);
		this.mapConfiguration.setOptions({ mapTypeId: 'hybrid', fullscreenControl: true })
	}
}
